import { ReactNode, useCallback } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext } from "@ryde/redux";
import { tableSearchAF } from "@ryde/shared";

import { useSearchHighlightDecorator } from "../grid/generic/table/search-highlight-context";
import { decorateGridValueWithSearch } from "./decorate-grid-value.helpers";

/** Grid cell templates inside SearchHighlightProvider. */
export const useDecorateWithMark = () => useSearchHighlightDecorator();

/** Standalone views (kanban row, reports builder) — one Recoil subscription per caller. */
export const useDecorateWithMarkLocal = () => {
  const { entity } = usePageContext();
  const searchValue = useRecoilValue(tableSearchAF(entity));

  const decorateValue = useCallback(
    (value: ReactNode): ReactNode =>
      decorateGridValueWithSearch(value, searchValue),
    [searchValue],
  );

  return { decorateValue };
};
